export class StockOutTransactionRequest{
    unitId?:number; 
    saleOrderId?:number;
    fromDate?:any;
    toDate?:any;
    transactionType?:string[];
   product?:number;
}